import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import piniaPersistConfig from './helper/persist'
import type { Config } from './interface/configStore.d'

export const useConfigStore = defineStore(
  'configStore',
  () => {
    const currentConfig = ref<Config | null>(null)

    const setCurrentConfig = (payload: Config | null) => {
      currentConfig.value = payload
      return Promise.resolve()
    }

    const getterCurrentConfig = computed(() => {
      return currentConfig.value
    })

    return {
      currentConfig,
      setCurrentConfig,
      getterCurrentConfig
    }
  },
  {
    persist: piniaPersistConfig('configStore')
  }
)
